<mat-card class="intro-card">
  <article class="grid-1-2 align-center">
    <aside class="grid-aside">
      <mat-icon>{{ icon }}</mat-icon>
    </aside>
    <section class="grid-main">
      <p class="intro-card-number">{{ content }}</p>
      <h3>{{ title }}</h3>
    </section>
  </article>
</mat-card>
